import { __makeTemplateObject, __read } from "tslib";
import React, { useState } from 'react';
import { css } from 'emotion';
import { Button } from '../Button';
import { TagItem } from './TagItem';
import { useStyles } from '../../themes/ThemeContext';
import { Input } from '../Input/Input';
export var TagsInput = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? 'New tag (enter key to add)' : _b, _c = _a.tags, tags = _c === void 0 ? [] : _c, onChange = _a.onChange;
    var _d = __read(useState(''), 2), newTagName = _d[0], setNewName = _d[1];
    var styles = useStyles(getStyles);
    var onNameChange = function (event) {
        setNewName(event.target.value);
    };
    var onRemove = function (tagToRemove) {
        onChange(tags === null || tags === void 0 ? void 0 : tags.filter(function (x) { return x !== tagToRemove; }));
    };
    var onAdd = function (event) {
        event.preventDefault();
        onChange(tags.concat(newTagName));
        setNewName('');
    };
    var onKeyboardAdd = function (event) {
        event.preventDefault();
        if (event.key === 'Enter' && newTagName !== '') {
            onChange(tags.concat(newTagName));
            setNewName('');
        }
    };
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: styles.tags }, tags === null || tags === void 0 ? void 0 : tags.map(function (tag, index) {
            return React.createElement(TagItem, { key: tag + "-" + index, name: tag, onRemove: onRemove });
        })),
        React.createElement("div", null,
            React.createElement(Input, { placeholder: placeholder, onChange: onNameChange, value: newTagName, onKeyUp: onKeyboardAdd, suffix: React.createElement(Button, { variant: "link", className: styles.addButtonStyle, onClick: onAdd, size: "md", disabled: newTagName.length === 0 }, "Add") }))));
};
var getStyles = function (theme) { return ({
    wrapper: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", "px;\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n  "], ["\n    height: ", "px;\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n  "])), theme.spacing.formInputHeight),
    tags: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    margin-right: ", ";\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    margin-right: ", ";\n  "])), theme.spacing.xs),
    addButtonStyle: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 -", ";\n  "], ["\n    margin: 0 -", ";\n  "])), theme.spacing.sm),
}); };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TagsInput.js.map